import { render, staticRenderFns } from "./cmsCategories.vue?vue&type=template&id=384a689c&scoped=true&"
import script from "./cmsCategories.vue?vue&type=script&lang=ts&"
export * from "./cmsCategories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384a689c",
  null
  
)

export default component.exports